export default {
  methods: {
    limitNum(ref, prop, length) {
      if (ref.value.length > length) {
        ref.value = ref.value.slice(0, length)
        this[prop] = ref.value
      }
    }
  },
}
